function showDimension(d_val) {
    d_val = (d_val && d_val.toUpperCase()) || "";
    $(".d_change_show").addClass("d_change_hide").removeClass("d_change_show");

    var selector = '';
    switch(true) {
        case (d_val == 'TWIN' || d_val == "SIMPLE"):
            selector = '.pdp_twin';
            break;
        case (d_val == 'TWINXL' || d_val == "TWIN XL" || d_val == "SIMPLEXL" || d_val == "SIMPLE XL"):
            selector = '.pdp_twinxl';
            break;
        case (d_val == 'FULL'|| d_val == "DOUBLE"):
            selector = '.pdp_full';
            break;
        case (d_val == 'QUEEN'):
            selector = '.pdp_queen';
            break;
        case (d_val == 'KING'):
            selector = '.pdp_king';
            break;
        case (d_val == 'CALKING' || d_val == "CAL KING" || d_val == "KING CAL"):
            selector = '.pdp_calking';
            break;
        case (d_val == 'STANDARD'):
            selector = '.pdp_standard';
            break;
        case (d_val == 'SHORT QUEEN'):
            selector = '.pdp_shortqueen';
            break;
        case (d_val == 'SPLIT KING'):
            selector = '.pdp_splitking';
            break;
    }

    if (selector) {
        $('.desktop-dimension span' + selector + ', .dimension p' + selector)
            .removeClass("d_change_hide").addClass('d_change_show');
    }
}

document.addEventListener('variant:change', (variant) => {
    var d_val = (variant.detail.variant.title && variant.detail.variant.title.toUpperCase()) || "";
    showDimension(d_val);
});

$('.o-select select').on('change', function() {
    var d_val = (this.value && this.value.toUpperCase()) || "";
    showDimension(d_val);
});

// Show dimensions for the initially selected variant on page load
$(function() {
    var initialSelect = $('select[name="options[Size]"], select[name="options[Taille]"]').first();
    if (initialSelect.length && initialSelect.val()) {
        showDimension(initialSelect.val());
    }
});
